import { render } from "./PlaygroundAndSidebar.vue?vue&type=template&id=1f9525d5&scoped=true"
import script from "./PlaygroundAndSidebar.vue?vue&type=script&lang=js"
export * from "./PlaygroundAndSidebar.vue?vue&type=script&lang=js"

import "./PlaygroundAndSidebar.vue?vue&type=style&index=0&id=1f9525d5&lang=scss"
import "./PlaygroundAndSidebar.vue?vue&type=style&index=1&id=1f9525d5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f9525d5"]])

export default __exports__